<template>
  <body class="bg-primarybg">
  <loader id="loader" class="hidden"></loader>
  <HeaderComponent/>
  <router-view />
  <FooterComponent/>
  </body>
</template>

<script>
import Loader from "./components/Loader.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
export default {
  name: "MemberEnrollmentForm",
  components: {
    HeaderComponent,
    FooterComponent,
    Loader
    }
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
</style>
